"use client";

import { getCookies } from "cookies-next/client";

import axios, { InternalAxiosRequestConfig } from "axios";
import qs from "query-string";

const baseURL = process.env.NEXT_PUBLIC_BASE_URL;

if (!baseURL) {
  throw new Error("NEXT_PUBLIC_BASE_URL is not defined");
}

export const api = axios.create({
  baseURL,
  paramsSerializer: (params) => {
    return qs.stringify(params, {
      arrayFormat: "comma",
      skipNull: true,
      skipEmptyString: true,
    });
  },
});

async function handleRequest(config: InternalAxiosRequestConfig<any>) {
  const cookies = await getCookies();
  if (!cookies) return config;

  const { vHdr: header, vPl: payload, vSg: signature } = cookies;
  const value = [header, payload, signature].join(".");

  if (header) {
    config.headers.Authorization = `Bearer ${value}`;
  }

  return config;
}

api.interceptors.request.use(handleRequest);
